import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal, NgbModalConfig } from '@ng-bootstrap/ng-bootstrap';
import { CountdownComponent } from 'ngx-countdown';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { debounceTime } from 'rxjs/operators';
import { AuthService } from 'src/app/auth/auth.service';
import { KycComponent } from 'src/app/kyc/kyc.component';
import { LoadMoneyComponent } from 'src/app/login-customer/load-money/load-money.component';
import { ReceiptmsgComponent } from 'src/app/login-customer/receiptmsg/receiptmsg.component';
import { DmtService } from 'src/app/services/dmt.service';

@Component({
  selector: 'app-yes-bank-beneficiary',
  templateUrl: './yes-bank-beneficiary.component.html',
  styleUrls: ['./yes-bank-beneficiary.component.scss']
})
export class YesBankBeneficiaryComponent implements OnInit {

  proceedTocBc: boolean;
  mobileNo: string;
  loggeninSenderDetails: any;
  benificaryDetails: any;
  displayedColumns: string[] = ['beneficiary_name', 'account_no', 'bank_name', 'ifc_code', 'imps-neft'];
  dataSource: any;
  addbenifiaryForm: FormGroup;
  submitted: boolean;
  sendingAmount = {};
  ifscCodeList = [];
  ifscCodeReq = {
    page: 1,
    size: 10
  }
  transType = 'imps';
  isloading: boolean;
  dailyTranferLimit = 10000;
  senderId: any;
  mobilenumbet: any;
  otpValidatedflag: boolean;
  remaininglimit: any;
  transferredAmt: any;


  title = 'autocomplete';

  options:any = ["Sam", "Varun", "Jasmine"];

  filteredOptions;


  formGroup : FormGroup;
  otpForm: FormGroup;
  otpflag: boolean = false;
  senderName: any;
  blockIndex: any;
  bene_id: any;
  closeResult: string;
  data: any;
  walletAmount: any;

  tdsPercentage: any;
  RetailerCommission: any;
  totalretailortdsAmount: any;
  customerCharges: any;
  RetailorCost: number;
  senderdata: any;
  enteredAmount: any;
  lat: number;
  lng: number;
  isEdit: boolean=false;
  editBenedetail: any;
  isResendEnable: boolean;
  @ViewChild('countdown') counter: CountdownComponent;
  serviceProvider: any;
  limit=50;
  offset=0;
  constructor(
    public dialog: MatDialog,
    public dmtServices: DmtService,
    private toastr: ToastrService,
    private activatedRoute: ActivatedRoute,
    private formBuilder: FormBuilder,
    private modalService: NgbModal,
    private authService: AuthService,
    private ngxService: NgxUiLoaderService,
    private router:Router,
    private spinner: NgxSpinnerService,

    config: NgbModalConfig, 
  ) {
    config.backdrop = 'static';
    config.keyboard = false;

    this.addbenifiaryForm = this.formBuilder.group({
      name: ['', Validators.required],
      benemobile: ['', Validators.required],
        title: ['', Validators.required],
        address: ['', Validators.required],
        city: ['', Validators.required],
        pincode: ['', Validators.required],
        account_no: ['', Validators.required],
        ifsc: ['', Validators.required],
        mobile: ['', Validators.required],
    });

    this.otpForm = this.formBuilder.group({
      otp: ['', Validators.required,Validators.minLength(6)],
     
    });
    
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(position => {
        this.lat = position.coords.latitude;
        this.lng = position.coords.longitude;
      });
    }
  }
   
  // selectBankByChip(bank, bankList) {
  //   bankList.forEach(element => {
  //     if (element.iinno == bank.iinno) {
  //       if (!element.selected) {
  //         element.selected = true;
  //         this.aepsForm.patchValue({
  //           selectedBank: bank.iinno,
  //         });
  //       } else {
  //         element.selected = false;
  //       }

  //     }
  //   });
  //   this.selectedBank = bank.value;
  // }
  initForm(){
    this.addbenifiaryForm.get('bank').valueChanges
    .pipe(debounceTime(1000))
    .subscribe(response => {
      if(response && response.length){
        this.filterData(response);
      } else {
        this.ifscCodeList = [];
      }
      
    })
  }

  filterData(enteredData){
    var bankName = enteredData.toUpperCase();
    this.dmtServices.getifc(this.ifscCodeReq,bankName).subscribe((response:any) => {
      this.options = response.data.result;
      this.filteredOptions = response.data.result;
      this.addbenifiaryForm.get('ifsccode').setValue(this.filteredOptions[0].bankIFSC)
    })
    // list.data.result.forEach(element => {
    //   if (element) {
        
    //     this.ifscCodeList.push(element);
    //   }
    // this.ifscCodeList = this.options.filter(item => {
    //   return item.bankName.toLowerCase().indexOf(enteredData.toLowerCase()) > -1
    // })
  }

  getNames(){
    var bankName = '';
    this.dmtServices.getifc(this.ifscCodeReq,bankName).subscribe((response:any) => {
      this.options = response.data.result;
      this.filteredOptions = response.data.result;
    })
  }
  ngOnInit() {
    this.initForm();
    this.getNames();
    this.activatedRoute.params.subscribe(params => {
      if (params.mobile) {
        // this.mobileNo = window.atob(params.mobile);
        this.senderId = params.id;  
        this.mobileNo = params.mobile;
        this.senderName = params.name;
        this.serviceProvider=params.bank;
        
      }
      console.log(params);

    });
    this.addbenifiaryForm.get('mobile').setValue(this.mobileNo)

   
  
    this.beneficiaryList(this.serviceProvider);
    this.getIfsCode();
    this.getDMTLimitSenderApi();
    this.fetchWalletBalance();
  }
  fetchWalletBalance() {
    this.authService.getRetailerWalletBalance().subscribe((res:any)=>{
      this.walletAmount = res.balance;
      
    });
  }
  getDMTLimitSenderApi(){
    this.dmtServices.getDMTLimitSender(this.mobileNo).subscribe((res:any)=>{
      if(res.object){
        this.remaininglimit = res.object.remaininglimit;
        this.transferredAmt = 25000 - this.remaininglimit;
      }else if(res.object == null || res.object == ''){
        this.remaininglimit = 25000;
        this.transferredAmt = 25000 - this.remaininglimit;
      }
    

    })
  }
  beneficiaryList(serviceProvider) {
    if(serviceProvider=='YesBank'){
      this.ngxService.start();
      this.dmtServices.getbenificiaryListYesBank(this.limit,this.offset,this.mobileNo).subscribe((list: any) => {
        this.benificaryDetails = list.object;
        this.dataSource = list.object;
        this.ngxService.stop();
      }, (err) => {
        this.ngxService.stop();
      });
    }else{
      this.ngxService.start();
      this.dmtServices.getbenificiaryList(this.senderId).subscribe((list: any) => {
        this.benificaryDetails = list.data;
        this.dataSource = list.data;
        this.ngxService.stop();
      }, (err) => {
        this.ngxService.stop();
      });
    }
   
  }
  close(content) {
    this.modalService.dismissAll(content);
    }
  sendmonet(element, amount,confirmationModal) {
    this.ngxService.start();
  this.senderdata=element;
  this.enteredAmount=amount;
    if(amount > this.walletAmount){
        this.toastr.error("Entered Amount can't be greater than Wallet Balance");
    }else{
      this.dmtServices.commissionPlanApi(amount,this.transType.toUpperCase()).subscribe((res:any)=>{
        this.ngxService.stop();
      
           
       if(res.status_code == 1){

        let todayDate = new Date();
        if (todayDate == element.transactionDate) {
          alert('date is same::::');
        } 
        if (element.transferLimit < amount) {
          this.toastr.error(`you have used Rs ${element.transferLimit}. Now you can trasfer Rs ${25000 - parseInt(element.transferLimit)}. for this benificiary.`, '');
          return;
        }
        this.tdsPercentage = res.tdsPercentage
        this.totalretailortdsAmount = res.totalretailortdsAmount;
      this.RetailerCommission = res.totalretailorCommissionBeforetds;
      this.customerCharges = res.totalCommission;
      this.RetailorCost = this.customerCharges - this.RetailerCommission;
     
        this.modalService.open(confirmationModal);
    
        
       }else{
        this.toastr.error(res.error.message)
  
       }
        },errData=>{
      this.ngxService.stop();

      })
   
    }
  
  
  }
  proceed(confirmationModal){
    this.spinner.show();
      const reqparams={
      amount: this.enteredAmount,
      comments: "Domestic Money transfer",
      // dmtimpsdetails: {
        beneficiaryAccountNumber: this.senderdata.account_no.toString().trim(),
        beneficiaryIFSCCode: this.senderdata.ifc_code.toString().trim(),
        beneficiaryName: this.senderdata.beneficiary_name.toString().trim(),
        customerEmailAddress: "",
        customerMobileNumber: this.senderdata.mobile,
        customerName: this.senderName,
        "latitute": this.lat,
        "longitute": this.lng,
        "rfu1": "string",
        "rfu2": "string",
        "rfu3": "string"

    }
    this.dmtServices.dmtImps(reqparams, this.transType).subscribe((res: any)=>{
      this.spinner.hide();


      if(res.status_code == 1){
        this.close(confirmationModal);
        const dialogRef = this.dialog.open(ReceiptmsgComponent, {
                hasBackdrop: false,
                disableClose: false,
                data: { inputLocalAccDetails: 'benificaryAccDetails', senderDetails: res }
              });
              dialogRef.afterClosed().subscribe(result => {
                // this.router.navigate(['/dashboard']);
                this.getDMTLimitSenderApi();
                this.sendingAmount={};
              });
            


      }else{
        this.close(confirmationModal);
        this.toastr.error(res.error.message)
      }
    }),errorData=>{
      this.spinner.hide();


    }
  }
  
  verify(bene){
    this.data=bene;
    const dialogRef = this.dialog.open(LoadMoneyComponent, {
      width: '400px',
      data: { Accdetails: bene }
    });
    dialogRef.afterClosed().subscribe(result => {
      if(this.serviceProvider=='YesBank'){
      this.beneficiaryList('YesBank');

      }else{
        this.beneficiaryList('IciciBank');

      }
      this.getDMTLimitSenderApi();

    });

  }
  

  loadMoney(beneficiary) {
    const dialogRef = this.dialog.open(LoadMoneyComponent, {
      data: { Accdetails: beneficiary }
    });
    dialogRef.afterClosed().subscribe(result => {
       });
  }
  getIfsCode() {
    var bankName="";
    this.dmtServices.getifc(this.ifscCodeReq,bankName).subscribe((list: any) => {
      if (list && list.data.result && list.data.result.length) {
        list.data.result.forEach(element => {
          if (element) {
            
            this.ifscCodeList.push(element);
          }
        });
      }
    });
  }
  getNextBatch() {
    this.ifscCodeReq = { ... this.ifscCodeReq, page: this.ifscCodeReq.page++ }
    this.getIfsCode();
  }
  procedWithBc() {
    this.proceedTocBc = true;
    this.addbenifiaryForm.get('beneficiary').reset();
    this.addbenifiaryForm.get('beneficiary').clearValidators();
    this.addbenifiaryForm.get('beneficiary').updateValueAndValidity();
  
    this.addbenifiaryForm.get('bank').reset();
    this.addbenifiaryForm.get('bank').clearValidators();
    this.addbenifiaryForm.get('bank').updateValueAndValidity();
  
    this.addbenifiaryForm.get('accno').reset();
    this.addbenifiaryForm.get('accno').clearValidators();
    this.addbenifiaryForm.get('accno').updateValueAndValidity();
  
    this.addbenifiaryForm.get('ifsccode').reset();
    this.addbenifiaryForm.get('ifsccode').clearValidators();
    this.addbenifiaryForm.get('ifsccode').updateValueAndValidity();
  
  }
 
  
  get f() { return this.addbenifiaryForm.controls; }
  get f2() { return this.otpForm.controls; }

  addWithoutVerify() {
    this.submitted = true;
    // stop here if form is invalid
    if (this.addbenifiaryForm.invalid) {
      return;
    }
    this.ngxService.start();
    var accountNumber=this.addbenifiaryForm.value.accno
    var senderId=this.senderId

    this.dmtServices.checkBeneAccount(accountNumber,senderId).subscribe((res:any)=>{
      this.ngxService.stop();

      if(res.status_code == 200){
      }else{
        this.ngxService.stop();

        this.toastr.error(res.error.message);

      }
    })
   
  
  }

  numberOnly(event): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }
cancel(){
  this.proceedTocBc=false;
  this.isEdit=false;
}
  increaseLimit() {
    const dialogRef = this.dialog.open(KycComponent, {
      data: { name: 'details', mobile: this.mobileNo }
    });
    dialogRef.afterClosed().subscribe(result => {
     });
  }
  bankchange() {
    this.addbenifiaryForm.patchValue({
      ifsccode: this.addbenifiaryForm.value.bank.IFSC_CODE
    });
  }
  openmodalforUserDeletion(id,modal,i) {
    this.blockIndex=i;
    this.bene_id = id;
    this.modalService.open(modal, {ariaLabelledBy: 'modal-basic-title'}).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      // this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }
  editBeneficiary(element,i){
    this.bene_id = element._id;

    this.proceedTocBc=true;
    this.isEdit=true;
    
    this.addbenifiaryForm.patchValue({
      beneficiary:element.beneficiary_name,
      bank:element.bank_name,
      accno:element.account_no,
      ifsccode:element.ifc_code,

    });
    
      var data={
      _id:element._id,
      senderId:element.senderId,
      bankVerify:element.bankVerify,
      block:element.block,
      dailyTransfer:element.dailyTransfer,
      kyc:element.kyc,          
      transferLimit:element.transferLimit
    }
    this.dmtServices.setEditBene(data);
   

  }
  
  userDeletionOk(){
    this.dmtServices.deleteBene(this.bene_id).subscribe((res:any)=>{
      if(res.status_code==200){
        document.getElementById("tab-pane-id").click();
         this.toastr.success(res.msg);
         if(this.serviceProvider=='YesBank'){
          this.beneficiaryList('YesBank');
    
          }else{
            this.beneficiaryList('IciciBank');
    
          }
      }else{
        this.toastr.error(res.message)
      }
    },err=>{
    })
      }
      
  sendOTP(){
        this.submitted = true;
        if (this.addbenifiaryForm.invalid) {
          return;
        }
        if(this.isEdit){
          this.dmtServices.deleteBene(this.bene_id).subscribe((res:any)=>{
            if(res.status_code==200){
              this.dmtServices.generateOtpYesBank(this.addbenifiaryForm.value,this.mobileNo).subscribe((res: any) => {
                if (res.status_code == 200) {
                 this.otpValidatedflag=true;

                 this.otpflag = true;
                 this.toastr.success(res.msg);
                 this.isResendEnable=false;

                } 
              })
            }else{
              this.toastr.error(res.message)
            }
          },err=>{
          })
        }else{
          this.dmtServices.checkBeneAccount(this.addbenifiaryForm.value.accno,this.senderId).subscribe((res:any)=>{
            this.ngxService.stop();
      
            if(res.status_code == 200){
               this.dmtServices.generateOtpYesBank(this.addbenifiaryForm.value,this.mobileNo).subscribe((res: any) => {
                  if (res.status_code == 200) {
                 this.otpValidatedflag=true;
                   this.otpflag = true;
                   this.toastr.success(res.msg);
                   this.isResendEnable=false;
  
                  } 
                })
      
  
            }else{
              this.ngxService.stop();
              this.toastr.error(res.error.message);
      
            }
          },err=>{
  
            this.toastr.error(err.error.message);
            this.ngxService.stop();
  
          })
        
        }
             
            
          }
          resendOTP() {
            this.ngxService.start();
            this.dmtServices.generateOtpYesBank(this.addbenifiaryForm.value,this.mobileNo).subscribe(
                (data: any) => {
                   this.ngxService.stop();
        
                   if (data.status_code == 200) {
                    this.isResendEnable = false;
            
                  } else {
                    this.toastr.error(data.error.message);
            
                  }
              },errData => {
                this.toastr.error(errData.error.message);
                this.ngxService.stop();
        
               
              }
            );
          }     
  ValidateOTP(otp){

    if(otp.length == 6){
      this.ngxService.start();
    
      this.dmtServices.createBeneficiaryYesBank(this.addbenifiaryForm.value,otp).subscribe((res: any)=>{
        this.ngxService.stop();

      if(res.status_code == 1){
        this.otpValidatedflag = true;
        this.toastr.success(res.msg);
        this.proceedTocBc = false;
        this.otpflag=false;
        this.otpValidatedflag= false;
        this.isEdit=false;

        this.addbenifiaryForm.controls['name'].reset()
        this.addbenifiaryForm.controls['benemobile'].reset()
        this.addbenifiaryForm.controls['title'].reset()
        this.addbenifiaryForm.controls['address'].reset()
        this.addbenifiaryForm.controls['city'].reset()
        this.addbenifiaryForm.controls['pincode'].reset()
        this.addbenifiaryForm.controls['account_no'].reset()
        this.addbenifiaryForm.controls['ifsc'].reset()

      }
    
     
    }, (err) => {
      this.ngxService.stop();
    });
     
  

    }
     }

     handleEvent(event) {
      if (event.action == 'finished') {
        this.isResendEnable = true;
      }
    }
}
